import React, { useMemo } from "react";
import { useOpen } from "../../../../hooks/useOpen";
import { getItemMenuProjectFiche } from "../helpers/getDataItem";
import { ButtonFab } from "../../../../components/Buttons/ButtonFab";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";




const ActionButtons = ({ activeModalDetailsProject, isDebugTesting, auth, projectDetails, getProjectDetails }) => {
    const { open, openMethod } = useOpen();

    const itemsMenu = useMemo(() =>
        getItemMenuProjectFiche({
            project: projectDetails,
            actionModal: activeModalDetailsProject,
            auth,
            getProjectDetails
        }),
        [auth, projectDetails, activeModalDetailsProject, getProjectDetails]
    )

    return (
        <>
            <ButtonFab
                menuItems={itemsMenu}
                actionActive={() => {
                    openMethod();
                }}
                valueOpen={open}
            />
            {isDebugTesting && (
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.modalDebugTaskCount);
                    }}
                    className="fixed z-30 right-5 p-1 rounded-lg bg-[#ffffff] border-[0.5px] border-black cursor-pointer"
                >
                    <p>Debug</p>
                </div>
            )}
        </>
    );
};

export default ActionButtons;
